import { CSSProperties } from "react";

// Mobile breakpoint utility
const MOBILE_BREAKPOINT = 768;
const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

// Responsive helper function
const responsive = (
  mobileStyles: CSSProperties,
  desktopStyles: CSSProperties = {}
): CSSProperties => {
  return isMobile() ? { ...desktopStyles, ...mobileStyles } : desktopStyles;
};

export { isMobile, responsive };

export default {
  //ConversationList
  appContainer: (alertsExist: boolean): CSSProperties => ({
    display: "flex",
    flexDirection: isMobile() ? "column" : "row",
    height: alertsExist ? "calc(100% - 122px)" : "calc(100% - 72px)",
    width: "100%",
    pointerEvents: alertsExist ? "none" : "auto",
  }),
  flex: {
    display: "flex",
  },
  //Overall
  appWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  } as CSSProperties,
  convosWrapper: {
    height: "100%",
    width: isMobile() ? "100%" : "320px",
    position: "relative",
    backgroundColor: "#F4F4F6",
    minWidth: isMobile() ? "auto" : "280px",
    maxWidth: isMobile() ? "100%" : "400px",
  } as CSSProperties,
  messagesWrapper: {
    flex: 1,
  } as CSSProperties,
  appHeader: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#06033A",
    padding: "20px 25px",
  },
  appLogoWrapper: {
    width: "40px",
    height: "40px",
    borderRadius: "5px",
    border: "1.25px solid #394762",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  } as CSSProperties,
  appLogoTitle: {
    fontSize: "14px",
    fontWeight: 600,
    textAlign: "center",
    color: "#FFFFFF",
    lineHeight: "20px",
    paddingLeft: "16px",
  } as CSSProperties,
  appLogoSubTitle: {
    fontSize: "12px",
    fontWeight: 600,
    textAlign: "left",
    color: "#AEB2C1",
    lineHeight: "20px",
  } as CSSProperties,
  userTile: {
    display: "flex",
    alignItems: "flex-start",
  },
  userName: {
    color: "#FFFFFF",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "20px",
    display: "flex",
    justifyContent: "center",
  } as CSSProperties,
  userStatus: {
    fontSize: "12px",
    display: "flex",
    flexDirection: "row",
    lineHeight: "20px",
    fontWeight: "400",
    alignItems: "center",
    justifyContent: "center",
  } as CSSProperties,
  paginationSpinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  } as CSSProperties,
  app: {
    flex: 1,
    height: "100%",
    width: "100%",
    position: "absolute",
  } as CSSProperties,
  buttonWrapper: {
    flexDirection: "row",
    paddingRight: "16px",
  } as CSSProperties,
  //ConversationContainer Right Side
  convosWrapperBox: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flex: 1, // Take remaining space
    minWidth: 0, // Allow shrinking
  } as CSSProperties,
  convoList: {
    overflowY: "auto",
    maxHeight: "calc(100% - 150px)",
    marginTop: "20px",
  } as CSSProperties,
  collapseButtonBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    paddingTop: isMobile() ? "10px" : "15px",
    paddingBottom: isMobile() ? "15px" : "20px",
    paddingRight: "16px",
    paddingLeft: "16px",
    position: "absolute",
    top: 0,
    borderTop: "1px solid #CACDD8",
    borderBottom: "1px solid #CACDD8",
    minHeight: isMobile() ? "44px" : "auto", // Touch-friendly minimum height
    alignItems: "center",
  } as CSSProperties,
  newConvoButton: {
    padding: "14px 16px",
    width: "100%",
    position: "absolute",
    bottom: 0,
  } as CSSProperties,
  searchBox: {
    paddingLeft: "16px",
    paddingRight: isMobile() ? "16px" : "60px",
    paddingBottom: isMobile() ? "8px" : "0px",
  } as CSSProperties,
  addParticipantsButton: {
    padding: "14px 16px",
    width: "100%",
  } as CSSProperties,
  loginContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: "#001489",
  } as CSSProperties,
  logo: {
    width: "42px",
  } as CSSProperties,
  loginTitle: {
    paddingTop: "2px",
    color: "#FFFFFF",
    fontSize: "20px",
    lineHeight: "28px",
    fontWeight: 500,
  } as CSSProperties,
  subTitle: {
    color: "#AEB2C1",
    fontSize: "14px",
    lineHeight: "20px",
    paddingBottom: "40px",
  } as CSSProperties,
  loginContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 3,
  } as CSSProperties,
  loginForm: {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
  } as CSSProperties,
  userInput: {
    paddingTop: "24px",
    width: "320px",
    marginLeft: "24px",
    marginRight: "24px",
  } as CSSProperties,
  passwordInput: {
    paddingTop: "16px",
    width: "320px",
    marginLeft: "24px",
    marginRight: "24px",
  } as CSSProperties,
  loginButton: {
    paddingTop: "32px",
    paddingBottom: "24px",
    marginLeft: "24px",
    marginRight: "24px",
  } as CSSProperties,
  loginBackground: {
    position: "absolute",
    alignSelf: "flex-end",
    top: "50%",
    height: "50%",
    width: "100%",
    backgroundColor: "#001489",
    overflow: "hidden",
  } as CSSProperties,
  modalInputLabel: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "20px",
  } as CSSProperties,
  settingsWrapper: {
    zIndex: 1,
    paddingTop: "22px",
  } as CSSProperties,
  optionWrapper: {
    width: "232px",
  } as CSSProperties,
  collapsedList: {
    width: isMobile() ? "60px" : "70px",
    minWidth: isMobile() ? "60px" : "70px",
  } as CSSProperties,
  mobileCollapseButton: {
    minHeight: "44px",
    minWidth: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: "8px",
    transition: "background-color 0.2s ease",
  } as CSSProperties,
  mobileTouchTarget: {
    minHeight: "44px",
    minWidth: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  } as CSSProperties,
  mobileSearchInput: {
    fontSize: "16px", // Prevents zoom on iOS
    padding: "12px 16px",
    borderRadius: "8px",
    border: "1px solid #CACDD8",
    width: "100%",
    boxSizing: "border-box" as const,
  } as CSSProperties,
  // Message container styles for full width
  messageContainer: {
    width: "100%",
    maxWidth: "100%",
  } as CSSProperties,

  chatBubble: {
    maxWidth: isMobile() ? "85%" : "70%",
    wordWrap: "break-word" as const,
    wordBreak: "break-word" as const,
    whiteSpace: "pre-wrap" as const,
  } as CSSProperties,

  chatBubbleOutbound: {
    maxWidth: isMobile() ? "85%" : "70%",
    marginLeft: "auto",
    wordWrap: "break-word" as const,
    wordBreak: "break-word" as const,
    whiteSpace: "pre-wrap" as const,
  } as CSSProperties,
};
